import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import { useSvgId } from 'src/hooks';

export const BonusCreditsIcon = React.forwardRef((props, ref) => {
  const svgId = useSvgId();

  return (
    <SvgIcon {...props} ref={ref} viewBox="0 0 15 14" data-fill-none>
      <g clipPath={`url(#${svgId})`}>
        <path
          d="M6.85782 7.77393C5.70479 7.77393 2.31127 7.77393 2.31127 7.77393C1.95102 7.77393 1.65625 8.06865 1.65625 8.42889V13.3451C1.65625 13.7053 1.95102 14.0001 2.31127 14.0001C2.31127 14.0001 5.7758 14.0001 6.93427 14.0001C7.08836 14.0001 7.08836 13.8345 7.08836 13.8345V7.9965C7.08831 7.9965 7.08831 7.77393 6.85782 7.77393Z"
          fill="currentColor"
        />
        <path
          d="M12.9707 7.77393C12.9707 7.77393 9.56424 7.77393 8.42882 7.77393C8.15218 7.77393 8.19361 8.06202 8.19361 8.06202V13.8399C8.19361 13.8399 8.19136 13.9999 8.35777 13.9999C9.51099 13.9999 12.9707 13.9999 12.9707 13.9999C13.3309 13.9999 13.6257 13.7052 13.6257 13.3449V8.42889C13.6258 8.06865 13.331 7.77393 12.9707 7.77393Z"
          fill="currentColor"
        />
        <path
          d="M7.0897 3.90554C7.0897 3.90554 7.0897 3.68359 6.87038 3.68359C5.55705 3.68359 1.57298 3.68359 1.57298 3.68359C1.21274 3.68359 0.917969 3.97837 0.917969 4.33856V6.38316C0.917969 6.74341 1.21274 7.03813 1.57298 7.03813C1.57298 7.03813 5.5749 7.03813 6.88832 7.03813C7.0897 7.03813 7.0897 6.86347 7.0897 6.86347V3.90554Z"
          fill="currentColor"
        />
        <path
          d="M13.712 3.68359C13.712 3.68359 9.72629 3.68359 8.3977 3.68359C8.19531 3.68359 8.19531 3.87643 8.19531 3.87643V6.86753C8.19531 6.86753 8.19531 7.03813 8.44136 7.03813C9.75898 7.03813 13.712 7.03813 13.712 7.03813C14.0722 7.03813 14.367 6.74341 14.367 6.38316V4.33856C14.367 3.97837 14.0722 3.68359 13.712 3.68359Z"
          fill="currentColor"
        />
        <path
          d="M4.86162 3.1992C4.56193 3.1992 4.28821 3.17544 4.04817 3.12853C3.43849 3.00942 3.01945 2.77759 2.7671 2.41988C2.541 2.09929 2.47181 1.70406 2.56138 1.24513C2.71829 0.442181 3.25753 0 4.07967 0C4.25366 0 4.44473 0.0200905 4.64764 0.0597465C5.16379 0.160581 5.82396 0.456545 6.41364 0.851435C7.41411 1.52148 7.4636 1.93804 7.41378 2.19311C7.34052 2.56791 6.99021 2.83571 6.34278 3.0119C5.90537 3.13092 5.3655 3.1992 4.86162 3.1992ZM4.07971 1.04981C3.76132 1.04981 3.6519 1.13876 3.59182 1.44642C3.54266 1.69795 3.60465 1.78581 3.62498 1.81468C3.71012 1.93541 3.93187 2.0361 4.24946 2.09809C4.42082 2.13159 4.63256 2.1493 4.86157 2.1493C5.36517 2.1493 5.80883 2.07299 6.10322 1.98953C6.12465 1.98347 6.15791 1.95813 6.12226 1.93689C5.73739 1.62337 5.03327 1.20471 4.44635 1.09004C4.30963 1.06341 4.18623 1.04981 4.07971 1.04981Z"
          fill="currentColor"
        />
        <path
          d="M10.44 3.19916C10.44 3.19916 10.44 3.19916 10.4399 3.19916C9.93606 3.19916 9.39624 3.13087 8.95883 3.01185C8.31135 2.83571 7.96108 2.56786 7.88783 2.19311C7.83806 1.93804 7.88745 1.52148 8.88801 0.851435C9.4776 0.456545 10.1378 0.160581 10.654 0.0597465C10.8569 0.0200905 11.048 0 11.2218 0C12.0442 0 12.5834 0.442229 12.7401 1.24518C12.8298 1.70406 12.7607 2.09929 12.5345 2.41988C12.2822 2.77764 11.8632 3.00942 11.2533 3.12853C11.0134 3.17534 10.7397 3.19916 10.44 3.19916ZM9.18775 1.93036C9.15363 1.95016 9.17014 1.98142 9.18784 1.98652C9.48209 2.07113 9.93043 2.1493 10.4399 2.1493C10.669 2.1493 10.8807 2.13159 11.0521 2.09809C11.3696 2.03606 11.5915 1.93541 11.6766 1.81468C11.697 1.78581 11.759 1.69795 11.7097 1.44642C11.6497 1.13876 11.5402 1.04981 11.2218 1.04981C11.1153 1.04981 10.992 1.06336 10.8552 1.09009C10.2682 1.20471 9.57261 1.61678 9.18775 1.93036Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={svgId}>
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0.644531)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
});
